var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationAlt = function SvgLocationAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M9 .75a9 9 0 0 0-9 9c0 7.08 8.25 12.413 8.595 12.63a.75.75 0 0 0 .81 0C9.75 22.163 18 16.83 18 9.75a9 9 0 0 0-9-9m0 20.093c-1.612-1.14-7.5-5.67-7.5-11.093a7.5 7.5 0 0 1 15 0c0 5.422-5.887 9.953-7.5 11.093"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M9 6a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 9 6m0 6a2.25 2.25 0 1 1 0-4.5A2.25 2.25 0 0 1 9 12"
  })));
};
export default SvgLocationAlt;